const passwordAgeLabel = (daysSinceChange, lang) => {
  if (daysSinceChange === null)
    return lang === "pl" ? "dawno temu" : "long ago";
  if (daysSinceChange === 1)
    return lang === "pl" ? "1 dzień temu" : "1 day ago";
  if (daysSinceChange < 365)
    return lang === "pl"
      ? `${daysSinceChange} dni temu`
      : `${daysSinceChange} days ago`;
  if (daysSinceChange < 730) return lang === "pl" ? "1 rok temu" : "1 year ago";
  if (daysSinceChange < 1095) return lang === "pl" ? "2 lata temu" : "2 years ago";
  if (daysSinceChange < 1460) return lang === "pl" ? "3 lata temu" : "3 years ago";
  if (daysSinceChange < 1825) return lang === "pl" ? "4 lata temu" : "4 years ago";
  return lang === "pl" ? "5 lat temu" : "5 years ago";
};

const renderIcon = (icon) => {
  switch (icon) {
    case "success":
      return (
        <svg width="24.238" height="15.569" viewBox="0 0 24.238 15.569">
          <g
            fill="none"
            stroke="var(--color-text)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.3"
            transform="translate(0.919 0.919)"
          >
            <path
              d="M27.764,6.818l-14.255,14-8.145-8"
              transform="translate(-5.364 -6.818)"
            />
          </g>
        </svg>
      );
    default:
      return (
        <svg width="32" height="32" viewBox="0 0 32 32">
          <g
            fill="none"
            stroke="var(--color-text)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.3"
          >
            <path
              d="M12.9,2.459,1.308,25.3a2.732,2.732,0,0,0,2.327,4.008H26.81A2.732,2.732,0,0,0,29.137,25.3L17.549,2.459A2.586,2.586,0,0,0,12.9,2.459Z"
              transform="translate(0.778 0.848)"
            />
            <line y2="10.933" transform="translate(16 9.653)" />
            <line y2="1.367" transform="translate(16 24.686)" />
          </g>
        </svg>
      );
  }
};

export { passwordAgeLabel, renderIcon };
